import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, Observable, tap } from "rxjs";
import { BaseRespone } from "src/app/models/common.response";
import { environment } from "src/environments/environment";
import { PatientAppointmentHistory } from "./patient-appointment-history.type";

@Injectable({ providedIn: 'root' })
export class PatientAppointmentHistoryService {

    private _patienthistories: BehaviorSubject<PatientAppointmentHistory[]> = new BehaviorSubject<PatientAppointmentHistory[]>([]);

    constructor(
        private _httpClient: HttpClient
    ) { }

    get patienthistories$(): Observable<PatientAppointmentHistory[]> {
        return this._patienthistories.asObservable();
    }

    getPatientHistory(patientId: number) {
        return this._httpClient.get<BaseRespone<PatientAppointmentHistory[]>>(`${environment.baseURl}/Appointment/patient/${patientId}/history`).pipe(
            tap((response) => {
                this._patienthistories.next(response.result);
            }),
            catchError((error) => {
                console.error('Error to fetching data:', error);
                throw error;
            })
        );
    }
}
